import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductDetail from '../components/ProductDetail';

const ProductDetailPage = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <ProductDetail />
      </main>
      <Footer />
    </div>
  );
};

export default ProductDetailPage;

